export const filterFacetNudgePillsParams = (
  currentFacetKey: string,
  selectedIdsSet: Set<string>,
) => {
  switch (currentFacetKey) {
    case 'workArrangement':
      return { workArrangement: Array.from(selectedIdsSet).join(',') };
    case 'workType':
      return { workType: Array.from(selectedIdsSet).join(',') };
    case 'salaryMin':
      return { salaryRange: `${Array.from(selectedIdsSet)[0]}-` };
    default:
      return {};
  }
};
